import type { InjectionKey } from 'vue';

export const backgroundColorInjectKey = Symbol() as InjectionKey<BackgroundColorKey>;
export const relsInjectKey = Symbol() as InjectionKey<Array<StoryblokStory> | null>;